import { useEffect, useState } from "react";
import { SelectorComparisonOperator } from "../Components/SelectorComparisonOperator";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { LoanLineEditor } from "../../LoanLine/LoanLineEditor";

interface addCondition {
    Loan: any;
    renderLoan: string;
}

interface Props {
    jsonProps: string;
    onChange: Function;
}

export const ListPropsLoans = ({ jsonProps, onChange }: Props) => {

    const [format, setFortmat] = useState<Partial<addCondition>>({});
    const [lista, setLista] = useState([]);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        try {
            if (jsonProps && jsonProps.trim() !== "") {
                const parsed = JSON.parse(jsonProps);
                if (Array.isArray(parsed)) {
                    setLista(parsed);
                } else {
                    toast.error("El formato de jsonProps no es una lista válida.");
                    setLista([]);
                }
            } else {
                setLista([]);
            }
        } catch (error) {
            toast.error("Error al parsear jsonProps.");
            setLista([]);
        }
    };


    const create = () => {
        if (!format.Loan) {
            toast.error("Debe seleccionar una linea de Credito");
            return;
        }

        setLista([...lista, format.Loan as addCondition]);

        setFortmat({
            renderLoan: "",
            Loan: null,
        });
    };

    const deleteItem = (index: number) => {
        const nuevaLista = lista.filter((_, i) => i !== index);
        setLista(nuevaLista);
    };

    useEffect(() => {
        if (onChange) {
            onChange(JSON.stringify(lista))
        }
    }, [lista])

    return (
        <div className="row">
            <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-5">
                        <LoanLineEditor renderLoan={format.renderLoan} label="" onChange={(e) => { setFortmat({ ...format, Loan: e?.IDLoanLine ? { IDLoanLine: e?.IDLoanLine, Name: e?.Name, Description: e?.Description } : null }) }} />
                    </div>

                    <div className="col-md-2 d-flex align-items-end">
                        <BasicButton eventClick={create} icon="ri-file-add-line">Agregar</BasicButton>
                    </div>
                </div>
            </div>

            {/* Tabla de condiciones */}
            <div className="col-md-12">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Linea de Credito</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lista.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{`${item.IDLoanLine} - ${item.Name}`}</td>
                                <td>
                                    <BasicButton
                                        eventClick={() => deleteItem(index)}
                                        icon="ri-delete-bin-line"
                                        children="Eliminar"
                                    />
                                </td>
                            </tr>
                        ))}
                        {lista.length === 0 && (
                            <tr>
                                <td colSpan={6} className="text-center">No hay lineas de creditos agregados</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {/* <PrintJson json={lista} /> */}
            </div>
        </div>
    );
}